import React from 'react';
import ReactDOM from 'react-dom/client';
import FittingPractice from './FittingPractice';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-fitting-practice',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<FittingPractice />
		</React.StrictMode>
	);
}
